import { type StopAppointment } from 'core/appointments/domain/Appointment'

import { type Contact, type Facility } from '../../domain/Facility'
import { type Carrier } from '../../domain/Shipment'
import { AppointmentDialog } from '../AppointmentDialog/AppointmentDialog'
import { OpenDockAppointmentDialog } from '../OpenDockAppointmentDialog/OpenDockAppointmentDialog'
import { OpenDockAppointmentDrawer } from '../OpenDockAppointmentDrawer/OpenDockAppointmentDrawer'
import { RegularAppointmentDrawer } from '../RegularAppointmentDrawer/RegularAppointmentDrawer'

type AppointmentDialogsProps = {
  showNewAppointmentDrawer: boolean
  showOpenDockAppointmentDrawer: boolean
  facilityContact?: Partial<Contact>
  shipmentUUID: string
  stopIndex: number
  stopDate: string
  appointment?: StopAppointment
  appointmentDialogIsOpen: boolean
  openDockAppointmentIsOpen: boolean
  facility?: Partial<Facility>
  onClose: () => void
  onConfirm: () => void
  shipmentCarrier: Carrier
}

export function AppointmentDialogs({
  showNewAppointmentDrawer,
  showOpenDockAppointmentDrawer,
  facilityContact,
  shipmentUUID,
  stopIndex,
  stopDate,
  appointment,
  appointmentDialogIsOpen,
  openDockAppointmentIsOpen,
  facility,
  onClose,
  onConfirm,
  shipmentCarrier,
}: AppointmentDialogsProps) {
  stopDate = stopDate || new Date().toISOString().slice(0, 10)

  if (showNewAppointmentDrawer) {
    return (
      <RegularAppointmentDrawer
        facilityContact={facilityContact}
        shipmentUUID={shipmentUUID}
        stopIndex={stopIndex}
        stopDate={stopDate}
        appointment={appointment}
        isOpen={appointmentDialogIsOpen}
        onClose={onClose}
        onConfirm={onConfirm}
      />
    )
  }

  if (showOpenDockAppointmentDrawer) {
    return (
      <OpenDockAppointmentDrawer
        isOpen={openDockAppointmentIsOpen}
        onClose={onClose}
        shipmentUUID={shipmentUUID}
        stopIndex={stopIndex}
        shipmentCarrier={shipmentCarrier}
        facilityTimezone={facility?.timezone}
        onConfirm={onConfirm}
      />
    )
  }

  return (
    <>
      <AppointmentDialog
        shipmentUUID={shipmentUUID}
        stopIndex={stopIndex}
        stopDate={stopDate}
        appointment={appointment}
        isOpen={appointmentDialogIsOpen}
        onClose={onClose}
        onConfirm={onConfirm}
      />
      <OpenDockAppointmentDialog
        shipmentUUID={shipmentUUID}
        stopIndex={stopIndex}
        stopDate={stopDate}
        appointment={appointment}
        facilityName={facility?.companyName}
        warehouseUUID={facility?.warehouseUuid}
        isOpen={openDockAppointmentIsOpen}
        onClose={onClose}
        onConfirm={onConfirm}
      />
    </>
  )
}
